var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"c-file flex"},[_c('i',{staticClass:"tf tf-fw tf-file",class:("tf-file-" + _vm.suffix)}),_c('a',{on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.fileName))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }